import { Button, chakra, Flex, FlexProps, Text } from "@chakra-ui/react";
import React from "react";
import EmptyPlaceholder from "./EmptyPlaceholder";
import NoAnalytics from "./NoAnalytics";
import NoClass from "./NoClass";
import NoComments from "./NoComments";
import NoLessons from "./NoLessons";
import NoMessages from "./NoMessages";
import NoNotifications from "./NoNotifications";
import NoPeople from "./NoPeople";

interface Props {
  title?: string;
  subtitle?: string;
  buttonTitle?: string;
  helpCaption?: string;
  type?: string;
  onClick?: any;
  height?: string;
  py?: any;
}

const DuoIcon = chakra(NoAnalytics);
export const ZeroAnalytics: React.FC<FlexProps> = ({ ...props }) => (
  <Flex flexDir="column" alignItems="center" justifyContent="center" py={4} textAlign="center" {...props}>
    <DuoIcon width="40px" fill="gray.300" color="gray.200" mb={1} />
    <Text fontSize="sm" fontWeight="700" color="gray.400">
      No Data Available
    </Text>
  </Flex>
);

const Empty: React.FC<Props & FlexProps> = ({ title, height = "70vh", py = 10, subtitle, buttonTitle, helpCaption, onClick, type }) => (
  <Flex
    flexDir="column"
    alignItems="center"
    justifyContent={type === "comments" || type === "notifications" || "messages" ? "center" : ""}
    py={py}
    textAlign="center"
    minHeight={height}>
    {!type && <EmptyPlaceholder />}
    {type === "comments" && <NoComments width="300px" />}
    {type === "lessons" && <NoLessons width="320px" />}
    {type === "class" && <NoClass width="40vw" />}
    {type === "people" && <NoPeople width="320px" />}
    {type === "notifications" && <NoNotifications width="38vw" />}
    {type === "messages" && <NoMessages width="20vw" />}
    <Text fontSize="lg" fontWeight="700" color="gray.400">
      {title}
    </Text>
    {subtitle && (
      <Text marginBottom="8" color="gray.400">
        {subtitle}
        <br />
        {helpCaption}
      </Text>
    )}
    {buttonTitle && (
      <Button colorScheme="blue" variant="solid" borderRadius="8px" size="lg" onClick={onClick}>
        {buttonTitle}
      </Button>
    )}
  </Flex>
);

export default Empty;
